export default {
    init() {
        if ($('.cards_slider').length) {
            $('.cards_slider').each(function() {
                var _this = this;

                const CARDS_SPACING = 333;
                const CARDS = $(_this).find('.cards_slider--card').length;
                const MAX = CARDS_SPACING * (CARDS - 1) * -1;

                $(_this)
                    .find('.cards_slider--left')
                    .addClass('is-disabled');

                $(_this)
                    .find('.cards_slider--right')
                    .on('click', function() {
                        $(_this)
                            .find('.cards_slider--direction')
                            .removeClass('is-disabled');
                        let first = $(_this)
                            .find('.cards_slider--card')
                            .first();
                        let margin_left = first.css('margin-left');
                        let shift_int = parseInt(margin_left.replace('px', ''));
                        let shift_new = shift_int - CARDS_SPACING;
                        if (shift_new <= MAX) {
                            shift_new = MAX;
                            $(this).addClass('is-disabled');
                        }
                        first.css('margin-left', shift_new + 'px');
                    });

                $(_this)
                    .find('.cards_slider--left')
                    .on('click', function() {
                        $(_this)
                            .find('.cards_slider--direction')
                            .removeClass('is-disabled');
                        let first = $(_this)
                            .find('.cards_slider--card')
                            .first();
                        let margin_left = first.css('margin-left');
                        let shift_int = parseInt(margin_left.replace('px', ''));
                        let shift_new = shift_int + CARDS_SPACING;
                        if (shift_new >= 0) {
                            shift_new = 0;
                            $(this).addClass('is-disabled');
                        }
                        first.css('margin-left', shift_new + 'px');
                    });
            });
        }
    }
};
